import * as React from 'react';

import FileIllustrator16 from './FileIllustrator16';

export const fileIllustrator16 = () => <FileIllustrator16 />;

export default {
    title: 'Icon/Fill/FileIllustrator16',
    component: FileIllustrator16,
    parameters: {
        notes: "`import FileIllustrator16 from 'box-ui-elements/es/icon/fill/FileIllustrator16';`",
    },
};
